import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';




import { SearchModule } from 'app/layout/common/search/search.module';



import { ModernLayoutComponent } from 'app/layout/layouts/horizontal/modern/modern.component';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
    exports: [
        ModernLayoutComponent
    ], imports: [RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    SearchModule,
    MatSelectModule, ModernLayoutComponent], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class ModernLayoutModule
{
}
